import gsap from 'gsap';
import { module } from 'modujs';
import IS_TOUCH_DEVICE from '../app';

export default class extends module {
    constructor(m) {
        super(m);

        this.hasTimelineInit = false;
    }

    init() {
        this.$slides = Array.from(this.$('slide'));

        this.initTimeline();
    }

    ////////////////////
    // Events
    ////////////////////
    onScroll(obj) {
        if(window.isMobile) {
            return;
        }

        try {
            const progress = obj.currentElement.progress;
            this.updateTimeline(progress);
        } catch (err) {
            console.error(err);
            return;
        }
    }

    ////////////////////
    // Methods
    ////////////////////

    // ==========================================================================
    // Timeline
    // ==========================================================================

    initTimeline() {
        this.timeline = gsap.timeline({ ease: "power2.inOut" });

        this.$slides.forEach(($item, index) => {
            const $label = $item.querySelector('[data-timeline-bw="label"]');
            const $image = $item.querySelector('[data-timeline-bw="image"]');

            if(index == 0) {
                if($label) {
                    this.timeline.fromTo($label, { y: '-50%' }, { y: '0%', duration: 0.5 }, '+=0');
                }

                this.timeline.to($item, { x: '-20%', duration: 1 }, '+=0');
            } else {
                this.timeline.addLabel(`slide-${index}`);

                this.timeline.fromTo($item, { x: '100%' }, { x: '0%', duration: 1 }, '-=1');

                if($label) {
                    this.timeline.fromTo($label, { x: '-50%' }, { x: '0%', duration: 1 }, '-=1');
                }

                if($image) {
                    this.timeline.fromTo($image, { x: '-50%' }, { x: '0%', duration: 1 }, '-=1');
                }
            }
        });

        this.timeline.pause();
        this.timeline.progress(0.1);
        this.timeline.progress(0);

        this.hasTimelineInit = true;
    }

    updateTimeline(progress) {
        this.timeline?.progress(progress);
    }

    inviewTimeline(event) {
        if(window.isMobile || !this.hasTimelineInit) {
            return;
        }

        if(event.way == 'exit' && event.obj.progress >= 1) {
            this.timeline.progress(1);
        }
    }

    killTimeline() {
        this.timeline?.kill();
        this.hasTimelineInit = false;
    }

    destroy() {
        super.destroy();
        this.killTimeline();
    }
}
